import { useContext } from "react";
import "../Operation.css";
import { Context } from "../../../context/Context";
import { translations } from "../../../utils/lang";
import MonthlyOperation from "./monthlyOperation/MonthlyOperation";
import ItemPerformance from "./itemPerformance/ItemPerformance";
import DailyOperation from "./dailyOperation/DailyOperation";
import Actions from "./action/Actions";
import ActiveCampaignsActions from "./activeActionCamp/ActiveCampaignsActions";
import ActionsStatus from "./actionsStatus/ActionsStatus";
import { getReadableTextColor } from "../operationUtils";
import { integrationLabel } from "../../../utils/integrations";

export default function OperationCard({
  menu,
  store,
  app,
  color,
  filters,
  refreshKey,
  onRefresh,
}) {
  const { lang } = useContext(Context);
  const appLabel = integrationLabel(app.app, lang);
  // Mutations inside this card refresh every card of the same store (a LUD
  // card lists actions from all of that store's apps).
  const refreshStore = () => onRefresh?.(store.id);

  return (
    <article
      className="operation-card"
      aria-label={`${store.storeName} • ${appLabel}`}
    >
      {/* White text is unreadable on yellow app colours, so pick by contrast. */}
      <div
        className="operation-card-header"
        style={{ backgroundColor: color, color: getReadableTextColor(color) }}
      >
        <div className="operation-card-subtitle">
          <p>
            {translations[lang].Operation.store} #{store.id}
          </p>
          <p aria-hidden="true"> • </p>
          <p>
            {translations[lang].Operation.app} #{app.id}
          </p>
        </div>
        <h2 className="operation-card-title">
          {store.storeName} • {appLabel}
        </h2>
      </div>

      <div className="operation-card-body">
        <MonthlyOperation
          storeId={store.id}
          appId={app.id}
          appName={app.app}
          monthlyDate={filters?.MonthlyDate}
        />
        <DailyOperation
          storeId={store.id}
          appId={app.id}
          appName={app.app}
          from={filters?.from}
          to={filters?.to}
        />
        <ItemPerformance
          storeId={store.id}
          appName={app.app}
          menuCount={menu}
          to={filters?.to}
        />
        <ActiveCampaignsActions
          storeId={store.id}
          appName={app.app}
          refreshKey={refreshKey}
          onRefresh={refreshStore}
        />
      </div>
      <div className="operation-card-body-row">
        <Actions
          storeId={store.id}
          appName={app.app}
          refreshKey={refreshKey}
          onRefresh={refreshStore}
        />
        <ActionsStatus
          storeId={store.id}
          appName={app.app}
          refreshKey={refreshKey}
        />
      </div>
    </article>
  );
}
